<template>
  <input :type="inputType" readonly :class="classStyle" @click="btnClick($event)"
    :disabled="classStyle==='disabled-btn'" :value="text">
</template>
<script>
  export default {
    props: {
      text: {
        type: [String, Number],
        default: '一颗小按钮'
      },
      inputType: {
        type: [String],
        default: 'button'
      },
      classStyle: {
        type: String,
        default: 'default-btn'
      }
    },
    methods: {
      btnClick(event) {
        if (!this.classStyle.includes('disabled-btn')) {
          this.$emit('btnClick', event)
        }
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/style/theme";

  %style {
    width: 58px;
    line-height: 22px;
    vertical-align: middle;
  }

  @mixin color($a, $b, $c) {
    border: 1px solid $a;
    border-radius: 4px;
    font-size: 12px;
    color: $b;
    background-color: $c;
  }

  input {
    display: inline-block;
    cursor: pointer;
    text-align: center;
  }

  // 默认按钮
  .default-btn {
    @include color(#e1e1e1, #646464, #f9f9f9);
    @extend %style;
    background-image: -webkit-linear-gradient(top, $cf, #f9f9f9);
    background-image: linear-gradient(180deg, $cf, #f9f9f9);

    &:hover {
      color: #00a5d5;
      background-color: #eee;
      background-image: -webkit-linear-gradient(top, #f5f5f5, #eee);
      background-image: linear-gradient(180deg, #f5f5f5, #eee);
    }
  }

  // 禁用
  .disabled-btn {
    cursor: not-allowed;
    @include color(#f5f5f5,#a9a9a9, #eee);
    @extend %style;
    background-image: -webkit-linear-gradient(top, #f5f5f5, #eee);
    background-image: linear-gradient(180deg, #f5f5f5, #eee);

    &:hover {
      color: #a9a9a9;
      background-color: #eee;
      background-image: -webkit-linear-gradient(top, #f5f5f5, #eee);
      background-image: linear-gradient(180deg, #f5f5f5, #eee);
    }
  }
</style>



// WEBPACK FOOTER //
// SButton.vue?c68eb1d4